import { render } from "./PhieuNhapKhoTableV2.vue?vue&type=template&id=7aa928d2&ts=true"
import script from "./PhieuNhapKhoTableV2.vue?vue&type=script&lang=ts"
export * from "./PhieuNhapKhoTableV2.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__